// src/contexts/NewArrivalContext.jsx

import React, { createContext, useContext, useEffect, useState } from 'react';
import { BASE_URL, UPLOAD_URL } from '../config/config';

const NewArrivalContext = createContext();

export const NewArrivalProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNewArrivals = async () => {
  setLoading(true);
  try {
    const res = await fetch(`${BASE_URL}/products`);
    const json = await res.json();
    if (res.ok && json.status === 200) {
      const newArrivalProducts = json.data
        .filter((product) => product.product_category_name === 'New Arrivals') // Assuming category_name is correct field
        .map((item) => ({
          id: Number(item.id),
          name: item.name,
          price: Number(String(item.amount).replace(/,/g, "")),        // ORIGINAL
          offer_price: item.offer_price
            ? Number(String(item.offer_price).replace(/,/g, ""))
            : 0,     
          status: item.status || 'Ready To Ship',
          category: item.category_name || 'Uncategorized',
          fabric: item.saree_fabric || 'N/A',
          image: item.images
            ? `${item.images.split(',')[0]}`
            : 'https://via.placeholder.com/300x400?text=No+Image',
          createdAt: item.create_audit_time,
        }));

      setProducts(newArrivalProducts);
    } else {
      throw new Error(json.message || 'Failed to fetch products');
    }
  } catch (err) {
    console.error('New Arrival fetch error:', err);
    setError(err.message || 'Error fetching products');
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchNewArrivals();
  }, []);

  return (
    <NewArrivalContext.Provider value={{ products, loading, error, refetch: fetchNewArrivals }}>
      {children}
    </NewArrivalContext.Provider>
  );
};

export const useNewArrivals = () => useContext(NewArrivalContext);
